import * as React from "react";
import { SVGProps, Ref, forwardRef } from "react";
function SvgInformationAlt(props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={ref}
      {...props}
    >
      <circle cx={16} cy={16} r={16} fill="#0763ED" />
      <path
        fill="white"
        fillRule="evenodd"
        d="M13.8 9.8001C13.8 8.58507 14.785 7.6001 16 7.6001C17.215 7.6001 18.2001 8.58507 18.2001 9.8001C18.2001 11.0151 17.215 12.0001 16 12.0001C14.785 12.0001 13.8 11.0151 13.8 9.8001ZM14.4999 14.4001H17.5002V24.4001H14.4999V14.4001Z"
        clipRule="evenodd"
      />
    </svg>
  );
}
const ForwardRef = forwardRef(SvgInformationAlt);
export default ForwardRef;
ForwardRef.defaultProps = {
  "aria-hidden": true,
  focusable: "false",
  role: "img",
};
